<template>
  <div class="steps-bd">
    <ul>
      <li
        class="ub"
        :class="{cur: item.value === value }"
        v-for="(item, index) in list"
        :key="index"
        @click="changeStep(item, index)"
      >
        <div class="step-l">
          <div class="dit">{{item.label}}</div>
          <div class="bar"></div>
        </div>
        <div class="step-r ub-f1 ub ub-xc">
          <div>
            <h1>{{item.title}}</h1>
            <p v-if="item.subTitle">{{item.subTitle}}</p>
            <p v-if="item.extra">{{item.extra}}</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    value: [String, Number],
    list: {
      type: Array,
      default() {
        return [
          {
            label: '',
            value: '',
            title: '',
            subTitle: ''
          }
        ];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    // 变更
    changeStep: function (item, index) {
      this.$emit('change', item);
      this.$emit('step', index + 1);
    }
  }
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';

.steps-bd {
  ul li {
    cursor: pointer;
    height: 90px;
    &:first-child .step-l .bar {
      top: 50%;
    }
    &:last-child .step-l .bar {
      bottom: 50%;
    }
    &.cur {
      background-color: #ffffff;
      .step-l {
        .dit,
        .bar {
          @include background_color_main();
        }
      }
      .step-r {
        h1,
        p {
          @include color_main();
        }
      }
    }
    .step-l {
      flex: 0 0 60px;
      padding-left: 20px;
      padding-top: 35px;
      position: relative;
      .dit {
        width: 18px;
        height: 18px;
        color: #ffffff;
        border-radius: 50%;
        background-color: #bebebe;
        line-height: 18px;
        text-align: center;
        font-size: 12px;
        position: relative;
        z-index: 10;
      }
      .bar {
        position: absolute;
        width: 1px;
        background-color: #cfd2d6;
        top: 0;
        bottom: 0;
        left: 28px;
      }
    }
    .step-r {
      overflow: hidden;
      h1 {
        font-size: 12px;
        color: #495057;
        line-height: 17px;
        font-weight: bold;
      }
      p {
        color: #6c757d;
        font-size: 12px;
        line-height: 17px;
        margin-top: 5px;
      }
    }
  }
}
</style>
